var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){$event.stopPropagation();}}},[(_vm.loading)?_c('div',{staticClass:"lightbox__loading"}):_vm._e(),_c('transition',{attrs:{"name":"lightbox-fade"}},[_c('img',{key:_vm.src,staticClass:"lightbox__image",style:(_vm.style),attrs:{"src":_vm.src,"alt":!_vm.loading ? 'Image' : ''}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }